import { Routes, Route } from "react-router";
import AccountsMain from "Modules/accounts/views/main";
import AccountOverview from 'Modules/accounts/views/overview';
import AccountVideoReview from "Modules/accounts/.components/tabEdgeTensor";
import { HasPermission } from "Core/security";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AccountsView = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "cmp") && <Route path="list" element={<AccountsMain />} />}
                {HasPermission(user, "cmp") && <Route path="overview/:id" element={<AccountOverview />} />}
                {HasPermission(user, "vdrvw") && <Route path="videoreview" element={<AccountVideoReview />} />}
                <Route path="*" element={<Navigate to="/error" />} />
            </Routes>
        </>
    )
}
export default AccountsView;